import { render, staticRenderFns } from "./DomainStatus.vue?vue&type=template&id=01f1250a&"
import script from "./DomainStatus.vue?vue&type=script&lang=js&"
export * from "./DomainStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports